<div class="error-container">
  <h1 align="center">Page not found</h1>
  <h2 align="center">404</h2>
</div>

